import { createMuiTheme } from "@material-ui/core/styles";

export default createMuiTheme({
  palette: {
    primary: {
      main: "#778899",
    },
    secondary: {
      main: "#006400",
    },
  },
  typography: {
    h6: {
      fontFamily: "Montserrat, sans-serif",
    },
  },
});
